<template>
  <div class="pagination" v-if="totalPages > 0">
    <v-pagination
      v-model="currentPage"
      :length="totalPages"
      @input="handlePageChange"
      :total-visible="totalVisible"
      :prev-icon="!$store.state.isScreenMobile ? 'Previous' : ''"
      :next-icon="!$store.state.isScreenMobile ? 'Next' : ''"
    ></v-pagination>
  </div>
</template>
  
  <script>
export default {
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    totalVisible:{
        type: Number,
        default:7
    },
    currentPage:{
      type: Number,
      default:1
    }
  },
  data() {
    return {
      // currentPage: 1,
    };
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      this.$emit("page-change", page);
    },
  },
};
</script>

<style lang="scss">
@import '~ThemePath/scss/common/_pagination.scss';
</style>
